import React from 'react'

function PilotScaleView() {
  return (
    <div>PilotScaleView</div>
  )
}

export default PilotScaleView